module.exports = __webpack_public_path__ + "static/img/img-jq-wechart.c788cdd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-jq-wechart.jpg
// module id = /Hka
// module chunks = 1